// extracted by mini-css-extract-plugin
export default {"Container":"Policy_Container__35qD6","Card":"Policy_Card__Ep4ct"};